<template>
  <div :class="{ 'live-order': true, live_light: theme == 'light' }">
    <div class="header">
      <span v-for="item in tableHeader" :key="item">{{ item }}</span>
    </div>
    <div class="body-content">
      <div class="body-item" v-for="item, index in tableData" :key="index">
        <span>
          <!-- <img :src="v(`@/assets/images/第${index+1}.png`)" alt=""> -->
          <img v-show="index === 0" src="@/assets/images/第1.png" alt="">
          <img v-show="index === 1" src="@/assets/images/第2.png" alt="">
          <img v-show="index === 2" src="@/assets/images/第3.png" alt="">
        </span>
        <span>{{ item.objname }}</span>
        <span>{{ (item.hourrf * 1).toFixed(1) }}mm</span>
      </div>
    </div>
  </div>
</template>

<script>
import { apiData } from '@/api'
export default {
  props: {
    theme: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      tableHeader: ['排名', '地点', '雨量'],
      tableData: [
        {}, {}, {}
      ]
    }
  },
  created() {
    this.getObjRainSort()
  },
  methods: {
    async getObjRainSort() {
      const company = this.$route.query.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const result = await apiData.getObjRainSort(unit.id)
      if (result.status === 200) {
        this.tableData = result.data.slice(0, 3)
        this.$emit('changeTime', this.$moment(this.tableData[0].timeLong).format('YYYY-MM-DD HH:mm'))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.live-order {
  display: flex;
  flex-direction: column;
  position: relative;
  left: 0;
  top: 0;
  z-index: 99;
  flex: 1;
  overflow: hidden;
  padding-top: 0.63vw;

  .header {
    display: flex;
    align-items: center;
    height: 2.71vw;
    margin-left: 1.11vw;
    background: #244274;
    border-radius: 0.21vw;

    span {
      flex: 2;
      text-align: center;
      font-size: 0.73vw;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 1.04vw;
    }

    span:nth-child(1),
    span:nth-child(3) {
      flex: 1;
    }
  }

  .body-content {
    flex: 1;
    overflow: hidden;
    // overflow-y: auto;

    .body-item {
      display: flex;
      align-items: center;
      height: 2.71vw;
      margin-left: 1.11vw;

      span {
        flex: 2;
        text-align: center;
        font-size: 0.73vw;
        color: #FFFFFF;
        line-height: 1.04vw;
      }

      span:nth-child(1),
      span:nth-child(3) {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        overflow: hidden;

        img {
          width: 2.08vw;
        }
      }
    }
  }
}

.live_light {
  .header {
    background: #ECF0F7;

    span {
      color: #333333;
    }
  }

  .body-content {
    .body-item {
      span {
        color: #333333;
      }
    }
  }
}
</style>
